var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.173 2.76a10.002 10.002 0 0113.065 13.067A9.999 9.999 0 0112 22a.75.75 0 010-1.5 8.502 8.502 0 006.01-14.51 8.5 8.5 0 00-14.467 5.157l.677-.677a.75.75 0 111.06 1.06l-1.823 1.824a1 1 0 01-1.414 0L.22 11.53a.75.75 0 111.06-1.06l.75.75a10 10 0 016.143-8.46z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25a.75.75 0 01.75.75v5.712l4.308 4.786a.75.75 0 01-1.116 1.004l-4.692-5.214V6a.75.75 0 01.75-.75z",
    fill: "currentColor"
  })));
}
SvgTransactionHistory.displayName = 'TransactionHistory';
export default SvgTransactionHistory;